import styled from 'styled-components';
import {SectionHeader} from '../../../../CommonStyleUtils/dwebCommon.styles';

export const BlueBackGroundWrapper = styled.section(
  props => `
    width:100%;
    background-color: ${props.theme.colors.goBrandBlue.base};
    position:absolute; top: 0; right:0; left:0;
    height:34rem;
    `,
);

export const ReviewBookingTextDiv = styled.div(
  props => `
  display:flex;
  z-index: 1;
  max-width: 120rem;
  margin: 0 auto;
  width: 100%;

  `,
);
export const ReviewBookingTextPara = styled(SectionHeader)(
  props => `
    color:${props.theme.colors.goWhite.base};
    padding:${props.theme.spacing.custom(30)} 0
    z-index:${props.theme.misc.zIndex.large};

`,
);

export const ReviewMainComponentWrapDiv = styled.div(
  props => `
    display:flex;
    justify-content: space-between;
    padding-bottom:${props.theme.spacing.xxlarge};
    z-index: 1;
    max-width: 120rem;
    margin: 0 auto;
    width: 100%;
  `,
);

export const LeftSection = styled.div(
  props => `
  width: 66%
  z-index: 5;
  `,
);

export const RightSection = styled.div(
  props => `
  width: 32%
  z-index: 5;
  > div{
    &:last-child{
      margin-top: ${props.theme.spacing.custom(12)};
    }
  }

  `,
);
